// This file is generated automatically by `scripts/build/fp.ts`. Please, don't change it.

import { weeksToDays as fn } from "../weeksToDays.js";
import { convertToFP } from "./_lib/convertToFP.js";

export const weeksToDays = convertToFP(fn, 1);

// Fallback for modularized imports:
export default weeksToDays;
